import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { useGlobalContext } from "../data/GlobalContext";
import { useLocation } from "react-router-dom";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import LoginGlobal from "../data/LoginGlobal";
import ModulesLotteryDraw from "./promotion_modules/modules_lotterDraw";

export default function LotteryDraw({ isLightMode }) {
	const { promotionsData } = usePromotionsData();
	const data = promotionsData.find(
		(promo) => promo.title === "2/30 Lottery Draw",
	);
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const [activeModal, setActiveModal] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		const loggedInState = localStorage.getItem("isLoggedIn") === "true";
		setIsLoggedIn(loggedInState);
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const location = useLocation();
	const isAppPromo = location.pathname.startsWith("/app-promotion");

	useEffect(() => {
		const isAppPromotion = location.pathname.startsWith("/app-promotion");

		if (isAppPromotion) {
			const theme = isLightMode ? "light" : "dark";
			document.documentElement.dataset.theme = theme;
			localStorage.setItem("theme", theme);
		}
	}, [location.pathname]);

	const modalComponents = {
		"2/30 Lottery Draw": ModulesLotteryDraw,
	};

	// promo expired
	useEffect(() => {
		if (!data) {
			navigate("/not-found");
		}
	}, [data, navigate]);

	if (!data) return null;
	const ActiveModal = activeModal ? modalComponents[activeModal] : null;
	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>2/30 Lottery Draw</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			{ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions{" "}
							</a>{" "}
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH ${data.title}`}
							/>
						</div>
						<div className="promotion-tnc-content">
							<div className="promotion-tnc-info">
								<div
									className={`promotion-indication-message ${data.promotionMessage.class}`}
								>
									{data.promotionMessage.text}
								</div>
								<h1>2/30 Lottery Draw</h1>
								<h2>Guess the Winning Number</h2>
								<div className="promotion-tnc-period">
									<strong>Promo Period: </strong>
									<span>Weekly Promotion</span>
								</div>
							</div>
							<div className="promotion-tnc-mechanic-content">
								<strong>Mechanics: </strong>
								<ol>
									<li>
										<p>
											The 2/30 Icon will pop up when you log in to your account.
										</p>
									</li>
									<li>
										<p>Choose 2 numbers from 1 to 30.</p>
									</li>
									<li>
										<p>Each 2-number combination equals 1 bet entry.</p>
									</li>
									<li>
										<p>
											1 bet entry = PHP 10, which will be deducted from the
											player's balance upon entry, with potential winnings of
											PHP 2,500.
										</p>
									</li>
									<li>
										<p>
											You can rebuy multiple times to increase your chances of
											winning.
										</p>
									</li>
									<li>
										<p>
											To win, players must guess the 2 winning numbers correctly
											in any order.
										</p>
										<p>
											<span className="promotion-tnc-block-text">
												(For example, if Player A bets on 01 and 30 while Player
												B bets on 30 and 01, both players will win if the
												winning numbers are 01 and 30.)
											</span>
										</p>
									</li>
								</ol>
								<strong>Terms and Conditions:</strong>
								<ol>
									<li>
										<p>
											<b>Entry Limit:</b> The system will only accept 20 total
											entries per number combination across all players. Once
											the system receives 20 entries for a specific combination,
											no additional bets will be accepted for that combination.
										</p>
									</li>
									<li>
										<p>
											<b>Eligibility:</b> Only verified FGH players 21 years old
											and above are eligible to participate.
										</p>
									</li>
									<li>
										<p>
											<b>Cash Prizes:</b> Each winning combination is awarded
											PHP 2,500 prize and no rollover needed.
										</p>
									</li>
								</ol>
								<strong>Betting Periods:</strong>
								<ol>
									<li>
										<p>
											The deposit and guessing period is open from Friday 12:00
											PM to Thursday 4:00PM. During this time, qualifying
											players can participate in the guessing game.
										</p>
									</li>
									<li>
										<p>
											FGH 2/30 Lottery Draw is held every Thursday at 6:00PM via
											Facebook LIVE DRAW. You may follow us on our{" "}
											<a
												href="https://www.facebook.com/fghofficialpage"
												target="blank"
												rel="nofollow"
											>
												Facebook Page
											</a>{" "}
											to watch the live.
										</p>
									</li>
									<li>
										<p>
											The company reserves the right to amend or terminate the
											promotion at any time. The company reserves the right to
											reschedule draws in case of technical issues. All
											decisions are final.
										</p>
									</li>
								</ol>
								{!isAppPromo && (
									<div className="promotion-tnc-cta">
										{isLoggedIn ? (
											<button
												className="promotion-cta-btn"
												onClick={() => setActiveModal(data.title)}
											>
												Guess Now
											</button>
										) : (
											<LoginGlobal
												label="Guess Now"
												btnClass="promotion-cta-btn"
												onlyBtn={true}
											/>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
